import { useState, useEffect } from 'react';
import { authService } from '../services/authService';
/**
 * Custom hook for authentication
 * Manages authentication state and provides auth methods
 */
export function useAuth() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const [authToken, setAuthToken] = useState(null);
  const [userId, setUserId] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [isLoading, setIsLoading] = useState(false);  // Add this line with your other state hooks

  /**
   * Load auth data from localStorage
   */
  const loadAuthData = () => {
    const token = localStorage.getItem('authToken');
    const id = localStorage.getItem('userId');
    const role = localStorage.getItem('userRole');

    setAuthToken(token);
    setUserId(id);
    setUserRole(role);
    setIsAuthenticated(!!token);
    setIsLoading(false);
  };

  useEffect(() => {
    loadAuthData();
    // Check authentication status on mount
    const authStatus = localStorage.getItem('isAuthenticated');
    const userData = localStorage.getItem('userData');
    
    if (authStatus === 'true' && userData) {
      setIsAuthenticated(true);
      setUser(JSON.parse(userData));
    }
    
    setLoading(false);
  }, []);

  const login = (email, userData) => {
    localStorage.setItem('isAuthenticated', 'true');
    localStorage.setItem('userEmail', email);
    localStorage.setItem('userData', JSON.stringify(userData));
    localStorage.setItem('userRole', userData.role);
    localStorage.setItem('userId', userData.id);
    localStorage.setItem('authToken', userData.token);
    localStorage.setItem('fullName', userData.fullName);
    setIsAuthenticated(true);
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('userEmail');
    localStorage.removeItem('userData');
    localStorage.removeItem('userRole');
    localStorage.removeItem('onboardingComplete');
    localStorage.removeItem('userId');
    localStorage.removeItem('authToken')
    localStorage.removeItem('fullName')
    setIsAuthenticated(false);
    setUser(null);
  };

  const refreshToken = async (authToken) => {
    try {
      const response = await authService.refreshToken(authToken);  // Changed from token to authToken
      console.log(`✅ JWT Token refreshed successfully: ${JSON.stringify(response)}`);
      // Update tokens in localStorage
      if (response.token) {
        localStorage.setItem('authToken', response.token);
      }
      // Update userId and role if provided
      if (response.userId) {
        localStorage.setItem('userId', response.userId);
      }
      
      if (response.role) {
        localStorage.setItem('userRole', response.role);
      }
      localStorage.setItem('authResponse', JSON.stringify(response));
      return response;
    } catch (error) {
      console.error('❌ Failed to refresh JWT Token:', error);
      logout();
      localStorage.setItem('authResponse', null);
      return null;
    }
  };

  const updateUser = (userData) => {
    localStorage.setItem('userData', JSON.stringify(userData));
    setUser(userData);
    localStorage.setItem('userRole', userData.role);
    localStorage.setItem('userId', userData.id);
    localStorage.setItem('authToken', userData.token);
    localStorage.setItem('fullName', userData.fullName);
  };

  return {
    isAuthenticated,
    user,
    loading,
    login,
    logout,
    updateUser,
    authToken,
    userId,
    userRole,
    isLoading,
    refreshToken
  };
}
